'use strict';

Fotobook.projectLanguages = {
    'data': [],
    get: function (id) {
        return this.data[id];
    },
    getAll: function () {
        return this.data;
    },
    set: function (languages) {
        this.data = [];
        for (var i = 0; i < languages.length; i++) {
            this.data[languages[i].id] = languages[i];
        }
    },
};

$(document)
    .on(Fotobook.events.ONLINE_EDITOR_INIT_DATA, function (event, response) {
        if (response && response.projectLanguages) {
            Fotobook.projectLanguages.set(response.projectLanguages);
        }
    })
;
